import { useCallback, useRef, useState } from "react";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const inFlightRef = useRef(false);

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    if (inFlightRef.current) return;
    inFlightRef.current = true;

    setIsLoading(true);
    setError(null);
    try {
      const headers = { ...(requestConfig.headers || {}) };
      const method = (requestConfig.method || "GET").toUpperCase();
      const bodyId = requestConfig.body?.id || requestConfig.body?.paymentId;
      const urlMatch = requestConfig.url?.match(/([0-9a-fA-F-]{8,})/);
      const txnId = bodyId || (urlMatch ? urlMatch[1] : null);
      const idempotencyKey = txnId || `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      // Automatically attach Idempotency-Key and X-Request-Id for mutating requests
      if (["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
        if (!headers["Idempotency-Key"] && !headers["idempotency-key"]) {

          headers["Idempotency-Key"] = idempotencyKey;
        }
          headers["X-Request-Id"] = headers["Idempotency-Key"] || headers["idempotency-key"];
          headers["Idempotency-Key"] = idempotencyKey;

      }

      const response = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers,
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });

      if (!response.ok) {
        throw new Error("Request failed!");
      }

      const data = await response.json();

      if (applyData) {
        applyData(data);
      }
    } catch (err) {
      setError(err.message || "Something went wrong!");
    } finally {
      inFlightRef.current = false;
      setIsLoading(false);
    }
  }, []);

  return { isLoading, error, sendRequest };
};

export default useHttp;
